import { PurchasedEnergyType } from '../generated/graphql'

/**
 * According to section 2.4 in
 * "Energiatodistusopas 2018: Rakennuksen energiatodistus ja E-luvun määrittäminen, 1.11.2018"
 * published by Ympäristöministeriö, the Energy Efficiency Rating (EER) coefficients for different energy types are:
 * - kaukolämpö 0,5
 * - sähkö 1,2
 * - fossiiliset polttoaineet (esim. öljy) 1,0
 * - uusiutuvat polttoaineet (esim. puupelletti) 0,5
 * - kaukojäähdytys 0,28
 *
 * Currently we do not calculate energy results for different fuel types, so we use the higher value for all fuel types.
 */
export const energyTypeToEerCoefficientMap: Record<
  PurchasedEnergyType,
  number
> = {
  [PurchasedEnergyType.Heating]: 0.5,
  [PurchasedEnergyType.Cooling]: 0.28,
  [PurchasedEnergyType.Electricity]: 1.2,
  [PurchasedEnergyType.Fuel]: 1,
}
